// Работа формы на странице Контакты
itsoftApp.createModule("formContacts", function() {

    (function(w, d, $) {
        'use strict';

        function CTools() {
            var self = this;

            self.contactsFeedbackFormSelector = '[data-contacts-feedback-form="contacts-feedback-form"]';
        }

        CTools.prototype.Init = function() {
            var self = this;

            self.initDomElements();
            self.initHandlers();
        };

        CTools.prototype.initDomElements = function() {
            var self = this;

            self.contactsFeedbackForm = $(self.contactsFeedbackFormSelector);
        };

        CTools.prototype.initHandlers = function() {
            var self = this;

            if (typeof self.contactsFeedbackForm === 'object' && self.contactsFeedbackForm.length) {
                self.contactsFeedbackForm.submit(function(e) {
                    self.contactsFeedbackFormSubmit(this, e);
                });
            }
        };

        CTools.prototype.contactsFeedbackFormSubmit = function(formElement, event) {
            var self           = this;
            var formData;
            var responseObject = {};

            try {
                if (formElement && typeof formElement.nodeName !== 'undefined' && formElement.nodeName === 'FORM') {
                    formData = $(formElement).serialize();

                    self.send(formElement.action, formData, function(response) {
                        if (responseObject = getMessages(self.contactsFeedbackFormSelector, response)) {
                            if (responseObject['ERROR_MESSAGE'].length) {
                                for (var key in responseObject['ERROR_MESSAGE']) {
                                    // TODO: Временно выводим сообщения через alert. Нужно будет подготовить плашки для сообщений
                                    //alert('ERROR ' + responseObject['ERROR_MESSAGE'][key]);
                                    $(".form-feedback__title").html(responseObject['ERROR_MESSAGE'][key]);
                                    $(".form-feedback").addClass("is-opened");
                                }
                            }
                            else {
                                if (responseObject['SUCCESS_MESSAGE'].length) {
                                    for (var key in responseObject['SUCCESS_MESSAGE']) {
                                        // TODO: Временно выводим сообщения через alert. Нужно будет подготовить плашки для сообщений
                                        //alert('SUCCESS ' + responseObject['SUCCESS_MESSAGE'][key]);
                                        //$(".form-feedback").show();
                                        $(".form-feedback__title").html(responseObject['SUCCESS_MESSAGE'][key]);
                                        $(".form-feedback").addClass("is-opened");
                                        $('.contact-map__form')[0].reset();
                                    }
                                }
                            }
                        }
                    }, {
                        type        : 'POST',
                        dataType    : 'html',
                        processData : false
                    });
                }
            }
            catch (error) {
                console.error(error);
            }

            event.preventDefault();
        };

        CTools.prototype.send = function(url, data, callback, options) {
            if (data instanceof FormData) {
                data.append('AJAX_MODE', 'Y');
            }
            else {
                if (typeof data === 'object') {
                    data['AJAX_MODE'] = 'Y';
                }
            }

            if (typeof options !== 'object') {
                options = {
                    type        : 'GET',
                    dataType    : 'json',
                    processData : true
                };
            }

            $.ajax({
                url         : (url) ? url : w.location.pathname,
                data        : data,
                type        : options.type,
                dataType    : options.dataType,
                timeout     : 15000,
                processData : options.processData,
                beforeSend  : function() {},
                complete    : function() {},
                error       : function(jqXHR, textStatus) {
                    console.error(textStatus);
                }
            }).done(function(response) {
                if (typeof callback === 'function') {
                    callback(response);
                }
            });
        };

        // CTools.prototype.headerFixInit = function() {
        //  var $pageHeaderContainer           = $('.page-header__container');
        //  var $panel                         = $('#panel');
        //  var pageHeaderContainerPositionTop = 0;
        //
        //  $pageHeaderContainer.closest('.page-header').css({'z-index' : 888});
        //
        //  // Если административная панель скрыта, опускаем шапку на 40px
        //  if ($panel.height() === 39) {
        //      $pageHeaderContainer.css({'top' : '40px'});
        //  }
        //
        //  // Если административная панель отображена, опускаем шапку на 148px
        //  if ($panel.height() === 147) {
        //      $pageHeaderContainer.css({'top' : '148px'});
        //  }
        //
        //  // При скрытии административной панели подтягиваем шапку на 40px
        //  $('#bx-panel-hider').click(function() {
        //      $pageHeaderContainer.css({'top' : '40px'});
        //  });
        //
        //  // При отображении административной панели опускаем шапку на 148px
        //  $('#bx-panel-expander').click(function() {
        //      $pageHeaderContainer.css({'top' : '148px'});
        //  });
        //
        //  $(w).scroll(function() {
        //      if (this.scrollY !== 0) {
        //          if (pageHeaderContainerPositionTop === 0) {
        //              pageHeaderContainerPositionTop = parseInt($pageHeaderContainer.css('top'));
        //          }
        //
        //          $pageHeaderContainer.css({'top' : 0});
        //      }
        //      else {
        //          if (this.scrollY === 0) {
        //              $pageHeaderContainer.css({'top' : pageHeaderContainerPositionTop + 'px'});
        //              pageHeaderContainerPositionTop = 0;
        //          }
        //      }
        //  });
        // };

        function getMessages(selector, htmlText) {
            if (!selector || !htmlText) {
                return false;
            }

            var $containerElement;
            var $errorMessageElements;
            var $successMessageElement;
            var responseObject = {
                'ERROR_MESSAGE'   : [],
                'SUCCESS_MESSAGE' : []
            };

            try {
                $containerElement = $(htmlText).find(selector).addBack(selector);

                if (typeof $containerElement === 'object' && $containerElement.length === 1) {
                    $errorMessageElements  = $containerElement.find('[data-error-message="error-message"] .errortext');
                    $successMessageElement = $containerElement.find('[data-success-message="success-message"]');

                    $errorMessageElements.each(function() {
                        var errorText;

                        if (errorText = $.trim($(this).text())) {
                            responseObject['ERROR_MESSAGE'].push(errorText);
                        }
                    });

                    if ($successMessageElement.length) {
                        responseObject['SUCCESS_MESSAGE'].push($.trim($successMessageElement.text()));
                    }
                }
            }
            catch (error) {
                console.error(error);
            }

            return responseObject;
        }

        if (typeof $ === 'function') {
            $(d).ready(function() {
                w.CTools = new CTools();

                w.CTools.Init();
            });
        }
    })(window, document, jQuery);

});
